var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Cascader',{attrs:{"data":_vm.department,"load-data":_vm.loadData,"change-on-select":"","filterable":"","clearable":"","placeholder":"请选择或输入搜索部门"},on:{"on-change":_vm.handleChangeDep},model:{value:(_vm.selectDep),callback:function ($$v) {_vm.selectDep=$$v},expression:"selectDep"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }